import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';

export default function SlipCategoryToggle({ value, onChange }) {
  return (
    <Tabs value={value} onValueChange={onChange}>
      <TabsList className="bg-muted border border-border">
        <TabsTrigger value="salary_slip" className="data-[state=active]:bg-background">
          Salary Slip
        </TabsTrigger>
        <TabsTrigger value="fee_receipt" className="data-[state=active]:bg-background">
          Fee Receipt
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}

